var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlus = function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.602,
    cy: 9.6,
    r: 8.8,
    stroke: "var(--icon-circle-color, currentColor)",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--icon-plus-color, currentColor)",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M6.746 9.6h5.714M9.605 6.748v5.714"
  })));
};
export default SvgIconPlus;